import {Component} from '@angular/core';


@Component({
  selector: 'app-activity',
  styleUrls: ['./activity.component.scss'],
  templateUrl: './activity.component.html',
})
export class ActivityComponent {

}
